export enum ETypPozadavku {
    UPIS = 'UPIS',
    NAVYSENI = 'NAVYSENI',
    PREVOD = 'PREVOD',
    SICAV = 'SICAV',
    PREVODZPET = 'PREVODZPET'
}
